export const project_primary_color = window.env.GENERIC_FRONTEND_REACTJS_STATUS_PRIMARY_COLOR_PROJECTS;
export const project_font = window.env.GENERIC_FRONTEND_REACTJS_STATUS_FONT_PROJECTS;

export const projects_idGa = window.env.GENERIC_FRONTEND_REACTJS_STATUS_GOOGLE_ANALYTICS;